// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".k-user-avatar[data-v-3add5b41]  .v-responsive.v-image{height:100%!important;width:100%!important}.k-user-avatar[data-v-3add5b41]  .v-image__image--preload{-webkit-filter:none!important;filter:none!important;background-color:#fff}", ""]);
// Exports
module.exports = exports;
